var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "w-full flex justify-center h-36 my-10"
  }, [_vm.name === 'GRATUIT' ? _c('img', {
    attrs: {
      "src": "/assets/img/abonnements/Illustration_Gratuit.png",
      "alt": "Abonnement Gratuit"
    }
  }) : _vm.name === 'PILOTE' ? _c('img', {
    attrs: {
      "src": "/assets/img/abonnements/Illustration_Standart.png",
      "alt": "Abonnement Pilote"
    }
  }) : _vm.name === 'EXPERT' ? _c('img', {
    attrs: {
      "src": "/assets/img/abonnements/Illustration_Plus.png",
      "alt": "Abonnement Expert"
    }
  }) : _vm._e()]), _vm._v(" "), _c('h2', {
    staticClass: "text-4xl font-medium",
    class: `text-${_vm.colorTheme(_vm.name, true)}-600`
  }, [_vm._v("\n    " + _vm._s(_vm.name) + "\n  ")]), _vm._v(" "), _c('p', {
    staticClass: "text-base text-center mt-5"
  }, [_vm._v("\n    " + _vm._s(_vm.description) + "\n  ")])]);

}
var staticRenderFns = []

export { render, staticRenderFns }